// Use `--aug-ui-*` + Bootstrap vars only (no light-only hex fallbacks) so dark mode modals
// keep chip / control / menu surfaces and text in sync. See `frontend/.../styles.js` AUG_UI.
// Metronic modal uses `$modal-zindex: 799999999` — portaled menus must stack above (see SelectDropDown/styles.js).
const MENU_PORTAL_Z_INDEX = 800000000

const multiSelectSearchStyles = {
  option: (base) => ({
    ...base,
    color: 'var(--aug-ui-fg, var(--bs-body-color))',
    backgroundColor: 'var(--aug-ui-bg, var(--bs-body-bg))',
    ':active': {
      color: 'var(--aug-ui-fg, var(--bs-body-color))',
      backgroundColor: 'var(--aug-ui-hover, var(--bs-tertiary-bg))',
    },
    ':hover': {
      color: 'var(--aug-ui-accent, var(--bs-primary))',
      backgroundColor: 'var(--aug-ui-hover, var(--bs-tertiary-bg))',
    },
    padding: '0.5rem 1rem',
    fontWeight: 500,
    textOverflow: 'ellipsis',
    cursor: 'pointer',
  }),
  control: (base) => ({
    ...base,
    flexWrap: 'nowrap',
    width: '100%',
    '&:hover': { borderColor: 'var(--aug-ui-border, var(--aug-ui-divider-subtle))' },
    boxShadow: 'none',
    borderColor: 'var(--aug-ui-border, var(--aug-ui-divider-subtle))',
    backgroundColor: 'var(--aug-ui-bg, var(--bs-body-bg))',
    color: 'var(--aug-ui-fg, var(--bs-body-color))',
    fontWeight: 600,
  }),
  singleValue: (base) => ({
    ...base,
    color: 'var(--aug-ui-fg, var(--bs-body-color))',
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: 'transparent',
  }),
  clearIndicator: (base) => ({
    ...base,
    backgroundColor: 'transparent',
    color: 'var(--aug-ui-accent, var(--bs-primary))',
    fontWeight: 400,
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    width: 30,
    color: state.isFocused
      ? 'var(--aug-ui-fg, var(--bs-body-color))'
      : 'var(--aug-ui-fg-muted, var(--bs-secondary-color))',
  }),
  menu: (base) => ({
    ...base,
    boxShadow: '0 4px 8px 0 rgba(52, 58, 64, 0.15)',
    border: 'solid 1px var(--aug-ui-border, var(--aug-ui-divider-subtle))',
    backgroundColor: 'var(--aug-ui-bg, var(--bs-body-bg))',
    color: 'var(--aug-ui-fg, var(--bs-body-color))',
    borderRadius: '4px',
    overflow: 'hidden',
    minWidth: 165,
    maxHeight: 240,
    width: 'auto',
    zIndex: 100,
  }),
  menuList: (base) => ({
    ...base,
    padding: '0px',
    minWidth: 235,
    backgroundColor: 'var(--aug-ui-bg, var(--bs-body-bg))',
  }),
  menuPortal: (base) => ({ ...base, zIndex: MENU_PORTAL_Z_INDEX }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: 'var(--aug-ui-hover, var(--bs-tertiary-bg, var(--bs-secondary-bg)))',
    borderRadius: 10,
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: 'var(--aug-ui-accent, var(--bs-primary))',
    fontSize: '1rem',
    fontWeight: 500,
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: 'var(--aug-ui-accent, var(--bs-primary))',
    fontSize: '1rem',
    fontWeight: 500,
    ':hover': {
      color: 'var(--aug-ui-accent, var(--bs-primary))',
      backgroundColor: 'var(--aug-ui-hover, var(--bs-tertiary-bg))',
      borderRadius: 10,
    },
  }),
  // Custom `ValueContainer` is a plain div — `valueContainer` styles are not applied to it.
  // Keep the real react-select input visually invisible (no grey “bar”) while preserving focus/blur.
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    color: 'var(--aug-ui-fg, var(--bs-body-color))',
    caretColor: 'var(--aug-ui-fg, var(--bs-body-color))',
    backgroundColor: 'transparent',
    boxShadow: 'none',
  }),
  placeholder: (base) => ({
    ...base,
    position: 'relative',
    lineHeight: '2.5rem',
    color: 'var(--aug-ui-fg-muted, var(--bs-secondary-color))',
  }),
  valueContainer: (base, state) => ({
    ...base,
    color: 'var(--aug-ui-fg, var(--bs-body-color))',
    backgroundColor: 'transparent',
    width: state.isSelected ? '35%' : '70%',
    padding: '0 8px',
    flexWrap: 'nowrap',
    height: '30px',
  }),
  indicatorsContainer: (base) => ({
    ...base,
    justifyContent: 'space-between',
  }),
}

export default multiSelectSearchStyles
